import axios from 'axios';
import authHeader from './auth-header';
import config from '../config';

class UserService {
  // Helper function to ensure slash
  getUserEndpoint() {
    let endpoint = config.api.user;
    if (!endpoint.endsWith('/')) {
      endpoint += '/';
    }
    return endpoint;
  }

  getPublicContent() {
    return axios.get(config.api.baseUrl + '/test/all');
  }

  getUserBoard() {
    return axios.get(config.api.baseUrl + '/test/user', { headers: authHeader() });
  }

  getUserBalance() {
    return axios.get(this.getUserEndpoint() + "balance", {
      headers: authHeader()
    });
  }

  // ✅ Added: Get user messages
  getUserMessages() {
    return axios.get(this.getUserEndpoint() + "messages", {
      headers: authHeader()
    });
  }

  // ✅ Added: Mark a message as read
  markMessageAsRead(messageId) {
    return axios.put(this.getUserEndpoint() + `messages/${messageId}/read`, {}, {
      headers: authHeader()
    });
  }

  // ✅ Added: Get unread message count
  getUnreadMessageCount() {
    return axios.get(this.getUserEndpoint() + "messages/unread-count", {
      headers: authHeader()
    });
  }

  updateBalance(newBalance) {
    return axios.post(this.getUserEndpoint() + "update-balance", {
      newBalance: parseFloat(newBalance)
    }, {
      headers: authHeader()
    });
  }

  getUserProfile() {
    return axios.get(this.getUserEndpoint() + 'profile', { 
      headers: authHeader() 
    });
  }

  updateProfile(profileData) {
    return axios.post(this.getUserEndpoint() + 'update-profile', profileData, { 
      headers: authHeader() 
    });
  }

  buy(coin, value) {
    return axios.post(this.getUserEndpoint() + 'buy', { 
      coin, 
      value
    }, { 
      headers: authHeader() 
    });
  }

  sell(coin, value) {
    return axios.post(this.getUserEndpoint() + 'sell', { 
      coin, 
      value
    }, { 
      headers: authHeader() 
    });
  }

  getCurrentUser() {
    return JSON.parse(localStorage.getItem('user'));
  }
}

export default new UserService();